module.exports = __webpack_public_path__ + "img/9.8c5eb796.png";